<template>
  <div class="hdr-pills">
    <!-- AutoBuy -->
    <div class="pill" :class="{ off: !buyOn }">
      <button
        type="button"
        class="pill-label pill-toggle"
        @click.stop="toggleBuy"
        :title="buyOn ? 'Disable AutoBuy' : 'Enable AutoBuy'"
      >
        B
      </button>

      <span class="pill-value">{{ buyMsDisp }}</span>

      <div class="pill-btns">
        <button type="button" :disabled="!buyOn" @click.stop="addBuy(-50)">−</button>
        <button type="button" :disabled="!buyOn" @click.stop="addBuy(50)">+</button>
      </div>
    </div>

    <!-- AutoSell -->
    <div class="pill" :class="{ off: !sellOn }">
      <button
        type="button"
        class="pill-label pill-toggle"
        @click.stop="toggleSell"
        :title="sellOn ? 'Disable AutoSell' : 'Enable AutoSell'"
      >
        S
      </button>

      <span class="pill-value">{{ sellMsDisp }}</span>

      <div class="pill-btns">
        <button type="button" :disabled="!sellOn" @click.stop="addSell(-50)">−</button>
        <button type="button" :disabled="!sellOn" @click.stop="addSell(50)">+</button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, ref, watch } from 'vue'
import { clampMs, msDisp, normMs } from './utils'

const props = defineProps({
  launchCfg: {
    type: Object,
    default: () => ({ buyOn: false, buyMs: 0, sellOn: false, sellMs: 0 }),
  },
})

const emit = defineEmits(['cfg'])

const buyOn  = ref(!!props.launchCfg?.buyOn)
const sellOn = ref(!!props.launchCfg?.sellOn)
const buyMs  = ref(normMs(props.launchCfg?.buyMs))
const sellMs = ref(normMs(props.launchCfg?.sellMs))

watch(
  () => [props.launchCfg?.buyOn, props.launchCfg?.buyMs, props.launchCfg?.sellOn, props.launchCfg?.sellMs],
  () => {
    const v = props.launchCfg || {}
    buyOn.value  = !!v.buyOn
    sellOn.value = !!v.sellOn
    buyMs.value  = normMs(v.buyMs)
    sellMs.value = normMs(v.sellMs)
  },
  { immediate: true }
)

const buyMsDisp = computed(() => buyOn.value ? msDisp(buyMs.value) : 'off')
const sellMsDisp = computed(() => sellOn.value ? msDisp(sellMs.value) : 'off')

function pushCfg() {
  emit('cfg', { buyOn: buyOn.value, buyMs: buyMs.value, sellOn: sellOn.value, sellMs: sellMs.value })
}

function toggleBuy() {
  buyOn.value = !buyOn.value
  pushCfg()
}

function toggleSell() {
  sellOn.value = !sellOn.value
  pushCfg()
}

function addBuy(delta) {
  if (!buyOn.value) return
  buyMs.value = clampMs(buyMs.value + delta)
  pushCfg()
}

function addSell(delta) {
  if (!sellOn.value) return
  sellMs.value = clampMs(sellMs.value + delta)
  pushCfg()
}
</script>

<style scoped>
.hdr-pills { display:flex; align-items:center; gap:6px; }

/* pill */
.pill{
  display:flex;
  align-items:center;
  gap:4px;
  padding:2px 6px;
  border-radius:999px;
  border:1px solid #333;
  background:#0b0b0b;
}
.pill.off{ opacity:0.6; }

.pill-label{ font-size:10px; color:#9ca3af; }

.pill-toggle{
  border:1px solid #333;
  background:#141414;
  color:#aaa;
  border-radius:999px;
  font-size:10px;
  padding:1px 6px;
  cursor:pointer;
  line-height:1.2;
}
.pill-toggle:hover{ background:#1f2937; color:#e5e7eb; }

.pill-value{
  font-size:11px;
  font-weight:600;
  color:#e5e7eb;
  min-width:42px;
  text-align:right;
}

.pill-btns{ display:flex; align-items:center; gap:2px; }
.pill-btns button{
  border:1px solid #333;
  background:#141414;
  color:#aaa;
  border-radius:999px;
  font-size:10px;
  padding:1px 4px;
  cursor:pointer;
}
.pill-btns button:disabled{ opacity:0.5; cursor:default; }
.pill-btns button:not(:disabled):hover{ background:#1f2937; color:#e5e7eb; }
</style>
